export { SocketIoModule } from './socket-io.module';
export { WrappedSocket as Socket } from './socket-io.service';
